import { CleanMatch as CleanMatchComponent } from './CleanMatch.component'
import { connector } from './CleanMatch.connector'

export const CleanMatch = connector(CleanMatchComponent);
